class UFilteredListFilter extends Uneet {
  constructor (domElement, toggleCallback, updateCallback) {
    super(domElement)
    this.filterItems = []
    this.isOpen = false
    this.__toggleCallback = toggleCallback
    this.__updateCallback = updateCallback
    this.__init()
  }

  __init () {
    // bind open close
    const toggleBtn = this._e.querySelectorAll('button.toggle-filter-dd')[0]
    toggleBtn.onClick(() => {
      this.toggle()
    })

    // bind selection of filters
    const filterItems = this._e.querySelectorAll('li.u_filtered-list-filter-item')
    filterItems.forEach((filterItem) => {
      const obj = new UFilteredListFilterItem(
        filterItem,
        (alteredFilterItem) => {
          this.__updateCallback(this, alteredFilterItem)
        })
      this.filterItems.push(obj)
    })
  }

  // returns all filter items (for checkup on selectedFilters component)
  getFilterItemsForSelectedFilters () {
    let retArray = []
    this.filterItems.forEach((filterItem) => {
      retArray.push({
        token: this.filtertoken,
        id: filterItem.id,
        label: filterItem.label,
        isActive: filterItem.isActive,
        turnOffFunction: () => {
          filterItem.toggle(false)
        }
      })
    })
    return retArray
  }

  getActiveFilterItems () {
    let retArray = []
    this.filterItems.forEach((filterItem) => {
      if (filterItem.isActive) {
        retArray.push(filterItem)
      }
    })
    return retArray
  }

  toggle (force = null) {
    const initialValue = this.isOpen
    // force = true: open | force = false: close
    if (force === null) {
      this.isOpen = !this.isOpen
    } else {
      this.isOpen = force
    }
    this._e.toggleClass('isOpen', this.isOpen)

    if (initialValue !== this.isOpen) {
      this.__toggleCallback()
    }
  }

  deactivateAllFilterItems () {
    let anyChange = false
    this.filterItems.forEach((filterItem) => {
      if (filterItem.isActive) {
        filterItem.toggle(false)
      }
    })
  }
}
